import React from "react";
import cx from "classnames";
import UI from "../UI"

class ThemeColorPreview extends React.Component {

    constructor(props) {
        super(props);
    }

    renderColorPreview(name, clazz) {
        return (
            <div key={name} className={cx("bg-" + clazz, "color-preview")}>
                <span>{name}</span>
            </div>)
    }
    render() {
        let {client, theme} = this.props;
        var wdp = "wdp";
        return (
            <div className="rlz-common-widget theme-preview">
                <section className={cx(wdp, theme)}>
                    {['primary-color', 'bg-color'].map(e => {return this.renderColorPreview(e, e) })}
                    <div/>
                    {['gray-base', 'gray-darker', 'gray-dark', 'gray', 'gray-light', 'gray-lighter'].map(e => {return this.renderColorPreview(e, e) })}
                    <div/>
                    {['nav-color', 'nav-text-color'].map(e => {return this.renderColorPreview(e, e) })}
                    <div/>
                    {['success-color', 'neutral-color', 'alert-color'].map(e => {return this.renderColorPreview(e, e) })}
                    <div/>
                    {['win-color', 'draw-color', 'lost-color'].map(e => {return this.renderColorPreview(e, e) })}
                    <div/>
                    {['text-color', 'headings-color', 'link-color'].map(e => {return this.renderColorPreview(e, e) })}
                    <div/>
                    {['live-color'].map(e => {return this.renderColorPreview(e, e) })}
                    <div/>
                    {['chart-base-color', 'chart-text-color'].map(e => {return this.renderColorPreview(e, e) })}
                    <div/>
                </section>
            </div>
        );
    }
}
export default ThemeColorPreview;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/core/ThemeColorsPreview.js
 **/